

const state = () => ({
    isAuthenticated: false,
    apiVersion: "",
    isExpanded: localStorage.getItem("is_expanded") == "true", //bolean values in localStorage is saved as string, therefor this control
    showSubSettings: false, 
    pageHeader: "" 
})

// getters
const getters = {
}

//actions
const actions = {
    setLogin({ commit }){
        commit('setAuth');
    },
    setLogout({ commit }){
        commit('sidebarLogOut');
    },
}

const mutations = {
    setAuth(state){
        state.isAuthenticated = true;
        //console.log(state.isAuthenticated)
    },
    toggleIsExpanded(state){
        state.isExpanded = !state.isExpanded;
        localStorage.setItem("is_expanded", state.isExpanded)
    },
    setIsExpanded(state, boolValue){
        state.isExpanded = boolValue;
        localStorage.setItem("is_expanded", state.isExpanded)
    },
    toggleShowSubSettings(state){
        state.showSubSettings = !state.showSubSettings;
    },
    sidebarLogOut(state){
        state.isAuthenticated = false;
    },
    setCurrentPageHeaderText(state, text){ 
         
        state.pageHeader = text; 
    }
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }